<template>
  <div style="display: flex; flex-direction: row; justify-content: space-between">
    <wrapper-preview-category style="width: 48%">
      <template v-slot:header>Блокировка заявки</template>
      <v-divider class="my-3"/>
      <v-row v-if="organizationBlocked && !organizationAllFormsCheched">
        <v-col class="d-flex justify-start">
          Возможность подписания заявки появится после подтверждения проверки всех форм
        </v-col>
      </v-row>
      <v-row v-if="!organizationBlocked">
        <v-col class="d-flex justify-start">
          <v-btn

              class="blue__v-btn mr-5"
              :loading="loadingFile"
              :disabled="blockBtn"
              @click="getReport"
          >
            Формы для самопроверки
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="organizationBlocked && isAdmin">
        <v-col class="d-flex justify-start">
          <v-btn
              class="blue__v-btn mr-5"
              :loading="loadingFile"
              :disabled="blockBtn"
              @click="getReport"
          >
            PDF для админа
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="organizationBlocked">
        <div>
          <ul>
            <li>
              <v-checkbox
                  :disabled="organizationAllFormsCheched"
                  v-model="getBlockInfoOrganization.checkFrom1"
                  :value="true"
                  label="Подтверждаю полноту и достоверность внесения данных в форму 1"
                  @change="setAcception(1, getBlockInfoOrganization.checkFrom1)"
              />
            </li>
            <li>
              <v-checkbox
                  :disabled="organizationAllFormsCheched"
                  v-model="getBlockInfoOrganization.checkFrom2"
                  :value="true"
                  label="Подтверждаю полноту и достоверность внесения данных в форму 2"
                  @change="setAcception(2, getBlockInfoOrganization.checkFrom2)"
              />
            </li>
            <li>
              <v-checkbox
                  :disabled="organizationAllFormsCheched"
                  v-model="getBlockInfoOrganization.checkFrom3"
                  :value="true"
                  label="Подтверждаю полноту и достоверность внесения данных в форму 3"
                  @change="setAcception(3, getBlockInfoOrganization.checkFrom3)"
              />
            </li>
            <li>
              <v-checkbox
                  :disabled="organizationAllFormsCheched"
                  v-model="getBlockInfoOrganization.checkFrom4"
                  :value="true"
                  label="Подтверждаю полноту и достоверность внесения данных в форму 4"
                  @change="setAcception(4, getBlockInfoOrganization.checkFrom4)"
              />
            </li>
            <li>
              <v-checkbox
                  :disabled="organizationAllFormsCheched"
                  v-model="getBlockInfoOrganization.checkFrom5"
                  :value="true"
                  label="Подтверждаю полноту и достоверность внесения данных в форму 5"
                  @change="setAcception(5, getBlockInfoOrganization.checkFrom5)"
              />
            </li>
          </ul>
        </div>
        <file-container :cols="9" :currentStage="currentStage" :files-config="filesConfig" :disabled="true"
                        ref="fileContainer"/>
        <div v-if="organizationAllFormsCheched && isValidSystemSetup">
          <v-row class="mt-2">
            <v-col class="d-flex justify-start">
              <div v-if="isValidSystemSetup && !hasConfirmFile">
                <v-autocomplete
                    v-model="chosenCertificate"
                    :items="certificatesList"
                    label="Выберите сертификат, которым будет произведена подпись данных"
                    no-data-text="Нет доступных сертификатов"
                    dense
                    class="mt-2"
                    clearable
                    outlined
                ></v-autocomplete>
                <v-btn class="blue__v-btn" :disabled="blockBtn" :loading="signingFile"
                       @click="signFile('getOrgReport', 'downloadingPrint', 'KONVERT', null, `?orgId=${userId}`)">
                  Подписать
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="!isValidSystemSetup && organizationAllFormsCheched">
            <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно.
              Проверить проблемы можно на странице <a
                  href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
        </div>
        <v-divider class="my-3"/>
        <v-row>
          <v-col class=" d-flex justify-start">
            <v-btn
                :disabled="organizationSendKonvert"
                class="blue__v-btn"
                @click="blockKonvertOrg"
            >
              {{ organizationSendKonvert ? 'Заявка отправлена' : 'Отправить заявку' }}
            </v-btn>
          </v-col>
        </v-row>
        <v-dialog v-model="envelopeConfirm" width="700">
          <v-card>
            <v-card-title>После отправки конверта разблокировать кабинет будет нельзя.</v-card-title>
            <v-card-actions style="justify-content: space-evenly">
              <v-btn class="blue__v-btn pr-3" @click="blockKonvertOrg">Отправить</v-btn>
              <v-btn class="blue__v-btn pl-3" @click="envelopeConfirm = false">Отменить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-divider class="my-3"/>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn
              :class="organizationBlocked ? 'success__v-btn' : 'error__v-btn'"
              @click="blockOrg"
              :loading="loading"
              :disabled="blockBtn || organizationAllFormsCheched"
          >
            {{ organizationBlocked ? 'Разблокировать' : 'Заблокировать' }}
          </v-btn>
        </v-col>
      </v-row>
    </wrapper-preview-category>
    <div
        v-if="getBlockInfoOrganization.konvert && organizationBlocked"
        style="width: 48%" :class="konvertAcceptStatus"
    >
      <div class="application__status">
        <div>{{ konvertAcceptText }}</div>
        <div class="convert_span">Номер: {{ getBlockInfoOrganization.konvertNumber }}</div>
        <div class="convert_span">Дата: {{ receiptDate }}</div>
      </div>
    </div>
    <v-dialog v-model="errors.hasErrors" width="1200">
      <v-card>
        <v-card-title>Конкурсные группы по которым значения выходят за установленные ограничения</v-card-title>
        <v-card-text v-for="item in errors.errorsArray" :key="item.id" style="color: #00599B; font-weight: 500; ">
          {{ item }}
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="blue__v-btn pl-3" @click="errors.hasErrors = false">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {mapActions, mapGetters} from "vuex";
import UserController from "@/controllers/UserController";
import FileContainer from "@/containers/FileContainer";
import {setFileFunctions} from "@/mixins/fileFucntions";
import moment from 'moment';
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";

moment.locale('ru');

export default {
  name: "BlockPrint",
  components: {FileContainer, WrapperPreviewCategory},
  mixins: [setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      loading: false,
      loadingKonvert: false,
      loadingFile: false,
      envelopeConfirm: false,
      errors: {
        hasErrors: false,
        errorsArray: [],
      },
      filesConfig: [
        {
          name: 'Заявка (заявка загрузится автоматически после подписания)',
          types: ['application/pdf', 'application/x-zip-compressed'],
          typesForChose: ['application/pdf', 'application/x-zip-compressed'],
          id: null,
          fileType: 'KONVERT'
        },
      ]
    }
  },
  mounted() {
    if (this.organizationBlocked && this.organizationAllFormsCheched) {
      this.checkSystem()
    }
  },
  watch: {
    organizationAllFormsCheched(newval) {
      if (newval)
        this.checkSystem();
    }
  },
  computed: {
    ...mapGetters('checkFilled', {
      organizationSendKonvert: 'organizationSendKonvert',
      organizationBlocked: 'organizationBlocked',
      organizationAllFormsCheched: 'organizationAllFormsCheched',
      getBlockInfoOrganization: 'getBlockInfoOrganization',
      currentStage: 'currentStage',
      getFilesList: 'getFilesList'
    }),
    ...mapGetters('keycloak', {getFakeUser: 'getFakeUser', userId: 'userId', isAdmin: 'isAdmin'}),
    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else return !!(this.currentStage !== 4 || this.envelopeConfirm);
    },
    hasConfirmFile() {
      const cffile = this.getFilesList.filter(item => item.fileType === 'KONVERT')[0];
      return cffile !== undefined && cffile !== null && !!cffile.id;
    },
    receiptDate() {
      if (this.getBlockInfoOrganization.konvertAcceptDate) {
        return moment(this.getBlockInfoOrganization.konvertAcceptDate).format('LLL')
      } else {
        return '';
      }
    },
    konvertAcceptStatus() {
      if (this.getBlockInfoOrganization.konvertAccept === true) {
        return 'accept'
      } else if (this.getBlockInfoOrganization.konvertAccept === false) {
        return 'reject'
      } else if (this.getBlockInfoOrganization.konvertAccept === null) {
        return 'in-process'
      } else {
        return ''
      }
    },

    konvertAcceptText() {
      if (this.getBlockInfoOrganization.konvertAccept === true) {
        return 'Конверт принят'
      } else if (this.getBlockInfoOrganization.konvertAccept === false) {
        return 'Конверт отклонен'
      } else {
        return 'Ожидайте приема конверта'
      }
    },
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    setAcception(form,value) {
      UserController.setCheckForm(form, !!value);
    },
    initFiles() {
      this.$refs.fileContainer.initFiles()
    },
    blockOrg() {
      this.loading = true;
      UserController.setBlockOrganization(!this.organizationBlocked, "ORG_BLOCK")
          .then((data) => {
            if (data.hasErrors) {
              this.errors.hasErrors = true
              this.errors.errorsArray = data.errors
            }
          })
          .finally(() => this.loading = false)
    },
    async blockKonvertOrg() {
      this.loadingKonvert = true;
      UserController.setBlockOrganization(true, "KONVERT_BLOCK").finally(() => this.loadingKonvert = false)
      this.envelopeConfirm = false
    },
    async getReport() {
      this.loadingFile = true;
      await this.downloadBlockPrint(this.userId)
      this.loadingFile = false;
    },
  },
}
</script>

<style lang="sass">
.accept
  .application__status
    color: #155724 !important
    background: #d4edda !important
    border: 1px solid #c3e6cb !important


.reject
  .application__status
    color: #721c24 !important
    background: #f8d7da !important
    border: 1px solid #f5c6cb !important

.in-process
  .application__status
    color: #343434 !important
    background: #a8a8a8 !important
    border: 1px solid #343434 !important

.application-moderate
  text-align: center

.convert_span
  font-size: 12px
  font-weight: 400
</style>